import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { CreateAwardCriteriaGQL } from "../../generated/graphql/AwardCriteria/create-awardCriteria.graphql";
import { DeleteAwardCriteriaGQL } from "../../generated/graphql/AwardCriteria/delete-awardCriteria.graphql";
import { UpdateAwardCriteriaGQL } from "../../generated/graphql/AwardCriteria/update-awardCriteria.graphql";
import { GetAwardCriteriaGQL } from "../../generated/graphql/AwardCriteria/get-awardCriteria.graphql";
import { CreateAwardCriteriaMutation, CreateAwardCriteriaMutationVariables} from "../../generated/graphql/AwardCriteria/create-awardCriteria.graphql";
import { UpdateAwardCriteriaMutation, UpdateAwardCriteriaMutationVariables } from "../../generated/graphql/AwardCriteria/update-awardCriteria.graphql";
import { GetAwardCriteriaQuery } from "../../generated/graphql/AwardCriteria/get-awardCriteria.graphql";

export interface DeleteAwardCriteriaDto {
    id: number;
  }

@Injectable({
  providedIn: "root",
})
export class AwardCriteriaService {
  constructor(
    private createAwardCriteriaGQL: CreateAwardCriteriaGQL,
    private deleteAwardCriteriaGQL: DeleteAwardCriteriaGQL,
    private updateAwardCriteriaGQL: UpdateAwardCriteriaGQL,
    private getAwardCriteriaGQL: GetAwardCriteriaGQL
  ) {}


  createAwardCriteria(variables: CreateAwardCriteriaMutationVariables): Observable<CreateAwardCriteriaMutation> {
    console.log('Variables antes de mutação:', variables);
    return this.createAwardCriteriaGQL.mutate(variables).pipe(
      map((result) => result.data),
      catchError((error) =>
        throwError(() => new Error("Falha ao criar critério: " + error))
      )
    );
  }

  
  deleteAwardCriteria(id: number): Observable<boolean> {
    return this.deleteAwardCriteriaGQL.mutate({
      id: { id }
    }).pipe(
      map((result) => result.data.deleteAwardCriteria),
      catchError((error) =>
        throwError(() => new Error("Falha ao excluir critério: " + error))
      )
    );
  }
  

 
  updateAwardCriteria(
    variables: UpdateAwardCriteriaMutationVariables
  ): Observable<UpdateAwardCriteriaMutation> {
    return this.updateAwardCriteriaGQL.mutate({
      id: variables.id,
      data: variables.data,
    }).pipe(
      map((result) => result.data),
      catchError((error) => throwError(() => new Error("Falha ao atualizar critério: " + error))
      )
    );
  }


  getAwardCriteria(): Observable<GetAwardCriteriaQuery> {
    return this.getAwardCriteriaGQL.watch().valueChanges.pipe(
      map((result) => result.data),
      catchError((error) =>
        throwError(() => new Error("Falha ao buscar critérios: " + error))
      )
    );
  }
}
